var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: "通道详情",
        visible: _vm.visible,
        footer: null,
        width: "800px",
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-descriptions",
        { attrs: { column: 2, bordered: "" } },
        [
          _c(
            "a-descriptions-item",
            { attrs: { label: "通道ID" } },
            [
              _c("a-tag", { attrs: { color: "green" } }, [
                _vm._v(_vm._s(_vm.detailData.channelId)),
              ]),
            ],
            1
          ),
          _c("a-descriptions-item", { attrs: { label: "通道名称" } }, [
            _c("b", [_vm._v(_vm._s(_vm.detailData.channelName))]),
          ]),
          _c("a-descriptions-item", { attrs: { label: "接口代码" } }, [
            _vm._v(" " + _vm._s(_vm.detailData.ifCode) + " "),
          ]),
          _c("a-descriptions-item", { attrs: { label: "支付方式" } }, [
            _vm._v(" " + _vm._s(_vm.detailData.wayCode) + " "),
          ]),
          _c(
            "a-descriptions-item",
            { attrs: { label: "商户费率" } },
            [
              _c("a-tag", { attrs: { color: "blue" } }, [
                _vm._v(_vm._s(_vm.detailData.feeRate) + "%"),
              ]),
            ],
            1
          ),
          _c(
            "a-descriptions-item",
            { attrs: { label: "费用计算方式" } },
            [
              _c(
                "a-tag",
                {
                  attrs: {
                    color: _vm.detailData.feeType === 1 ? "orange" : "purple",
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.detailData.feeType === 1 ? "百分比" : "固定金额"
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c("a-descriptions-item", { attrs: { label: "单笔最小金额" } }, [
            _c("span", { staticClass: "amount-text" }, [
              _vm._v(_vm._s(_vm.formatAmount(_vm.detailData.minAmount))),
            ]),
          ]),
          _c("a-descriptions-item", { attrs: { label: "单笔最大金额" } }, [
            _c("span", { staticClass: "amount-text" }, [
              _vm._v(_vm._s(_vm.formatAmount(_vm.detailData.maxAmount))),
            ]),
          ]),
          _c("a-descriptions-item", { attrs: { label: "日累计限额" } }, [
            _c("span", { staticClass: "amount-text" }, [
              _vm._v(_vm._s(_vm.formatAmount(_vm.detailData.dayMaxAmount))),
            ]),
          ]),
          _c("a-descriptions-item", { attrs: { label: "月累计限额" } }, [
            _c("span", { staticClass: "amount-text" }, [
              _vm._v(_vm._s(_vm.formatAmount(_vm.detailData.monthMaxAmount))),
            ]),
          ]),
          _c(
            "a-descriptions-item",
            { attrs: { label: "状态" } },
            [
              _c("a-badge", {
                attrs: {
                  status: _vm.detailData.state === 1 ? "processing" : "error",
                  text: _vm.detailData.state === 1 ? "正常" : "禁用",
                },
              }),
            ],
            1
          ),
          _c("a-descriptions-item", { attrs: { label: "排序权重" } }, [
            _vm._v(" " + _vm._s(_vm.detailData.sortOrder || "--") + " "),
          ]),
          _c("a-descriptions-item", { attrs: { label: "创建时间", span: 2 } }, [
            _vm._v(" " + _vm._s(_vm.detailData.createdAt) + " "),
          ]),
          _c("a-descriptions-item", { attrs: { label: "更新时间", span: 2 } }, [
            _vm._v(" " + _vm._s(_vm.detailData.updatedAt) + " "),
          ]),
          _c("a-descriptions-item", { attrs: { label: "备注信息", span: 2 } }, [
            _vm._v(" " + _vm._s(_vm.detailData.remark || "--") + " "),
          ]),
        ],
        1
      ),
      _c("a-divider", [_vm._v("通道配置参数")]),
      _vm.detailData.configParams &&
      Object.keys(_vm.detailData.configParams).length > 0
        ? _c(
            "div",
            [
              _c(
                "a-descriptions",
                { attrs: { column: 1, bordered: "" } },
                _vm._l(_vm.detailData.configParams, function (value, key) {
                  return _c(
                    "a-descriptions-item",
                    { key: key, attrs: { label: key } },
                    [_c("pre", [_vm._v(_vm._s(value))])]
                  )
                }),
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "no-config" },
            [_c("a-empty", { attrs: { description: "暂无配置参数" } })],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }